import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { Globe, Plus, Lightbulb } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function WorldBuilder() {
  const { data: worlds, loading } = useFetch("/worlds");
  if (loading || !worlds) return <Loading />;

  return (
    <div>
      <PageHeader icon={Globe} title="World Builder"
        subtitle="Permanent locations with visual references, lighting and colour rules. AI reuses these so worlds stay visually consistent."
        actions={<button data-testid="add-world" onClick={() => toast("Describe a new world in the studio assistant to generate references.")}
          className="inline-flex items-center gap-2 rounded-full bg-magic px-4 py-2 text-sm font-semibold text-black"><Plus size={16} weight="bold" /> New World</button>} />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {worlds.map((w) => (
          <div key={w.id} data-testid={`world-${w.id}`} className="rounded-2xl overflow-hidden border border-white/8 panel-hover">
            <div className="relative h-44">
              <img src={w.image} alt={w.name} className="h-full w-full object-cover" />
              <div className="absolute inset-0 scrim" />
              <h3 className="absolute bottom-3 left-4 font-display text-2xl font-black text-white">{w.name}</h3>
            </div>
            <div className="p-5">
              <p className="text-sm text-zinc-300">{w.description}</p>
              <div className="mt-3 flex items-center gap-2">
                <Lightbulb size={15} weight="duotone" className="text-[#FFB800]" />
                <span className="text-xs text-zinc-400">{w.lighting}</span>
              </div>
              <div className="mt-3 flex items-center gap-2">
                {w.colors?.map((c) => <div key={c} className="h-6 w-6 rounded-md border border-white/10" style={{ background: c }} />)}
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {w.objects?.map((o) => <Tag key={o}>{o}</Tag>)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
